export const GLOBAL_BREAKPOINT = undefined;
export function createEditorComponentModel(entry) {
    return entry;
}
export function createEditorPanelEntry(entry) {
    return entry;
}
export function createGFPPEntry(entry) {
    return entry;
}
export function createQuickEditorControlEntry(entry) {
    return entry;
}
export function createTranslations(entry) {
    return async (locale) => {
        let messages = [];
        try {
            messages = await entry({ locale });
        }
        catch (_a) {
            messages = await entry({ locale: 'en' });
        }
        return messages.map(message => { var _a; return (_a = message === null || message === void 0 ? void 0 : message.default) !== null && _a !== void 0 ? _a : message; });
    };
}
export function createEditorMetadataEntry(entry) {
    return entry;
}
export function createComponentAddPanel(entry) {
    return entry;
}
export function createComponentResponsiveMetadata(entry, options) {
    return Object.assign(entry, options || {});
}
export function createComponentResponsiveAddPanel(entry) {
    return entry;
}
//# sourceMappingURL=createEditorModel.js.map